export default __webpack_public_path__ + "images/plus-circle.svg";